/**
 * 將會改動 Phaser 互動物件樹的 action 延後到目前輸入事件結束後執行。
 * 同一 target 等待執行期間只接受一次，避免 pointerup 連續觸發。
 */
export class CDeferredActionDispatcher<TTarget extends object> {
  private readonly pendingTargets = new WeakSet<TTarget>();

  dispatch(
    target: TTarget,
    schedule: (callback: () => void) => void,
    action: () => void
  ): boolean {
    if (this.pendingTargets.has(target)) return false;
    this.pendingTargets.add(target);

    try {
      schedule(() => {
        this.pendingTargets.delete(target);
        action();
      });
    } catch (error) {
      this.pendingTargets.delete(target);
      throw error;
    }

    return true;
  }
}
